import { Component, OnInit } from '@angular/core';
import { SidenavEnum } from './sidenav.enum';
import { environment } from '../../../environments/environment';
import { RegisteredService } from '@core/auth/services/registered.service';
import { MatDialog } from '@angular/material';
import { UserService } from '@accounts/user/services/user.service';
import { AuthService, UserService as AuthUserService } from '@core/auth';
import { Router } from '@angular/router';
import {UserMeModel} from '@core/api';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  GOOGLE_API_KEY = environment.googleMapsApiKey;

  title = 'Sir-rent: Cabinet';

  links = [];

  constructor(
    private registeredService: RegisteredService,
    private userService: UserService,
    private authUserService: AuthUserService,
    private authService: AuthService,
  ) {
    if (authUserService.loginIn) {
      this.links = SidenavEnum;
    }
  }

  ngOnInit() {
    if (this.authUserService.loginIn) {
      this.userService.getUser().subscribe(user => {
        if (!user.applied_terms && this.authService.currentRole.name === UserMeModel.RoleEnum.USER) {
          this.userService.termsDialog(user);
        } else {
          if (this.registeredService.value) {
            this.userService.informationDataDialog();
          }
        }
      });
    }
  }

}
